// extracted by mini-css-extract-plugin
export var addressFields = "_pr-0";
export var animationContainer = "_pr-1";
export var footer = "_pr-2";
export var lineItems = "_pr-3";
export var modalContent = "_pr-4";
export var orderName = "_pr-5";
export var strong = "_pr-6";
export var warning = "_pr-7";